export enum DateRanges {
  Today,
  ToTommorow,
  ThisWeek,
  ThisMonth,
  ToWeekEnd,
  ToMonthEnd,
  ToNextWeekEnd,
}
